<div mat-dialog-title class="name">
    Filtros Adicionales
</div>
  
<div mat-dialog-content>
  <span class="subtitle">*Máximo 1000 registros</span>
  
  <mat-form-field appearance="fill">
    <mat-label>Fecha Creación</mat-label>
    <mat-date-range-input [rangePicker]="pickerCreatedAt">
      <input matStartDate placeholder="Inicio" [(ngModel)]="additionalFilters.start_created_at" [ngModelOptions]="{standalone: true}" ngDefaultControl>
      <input matEndDate placeholder="Fin" [(ngModel)]="additionalFilters.end_created_at" [ngModelOptions]="{standalone: true}" ngDefaultControl>
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="pickerCreatedAt"></mat-datepicker-toggle>
    <mat-date-range-picker #pickerCreatedAt></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Fecha Finalización</mat-label>
    <mat-date-range-input [rangePicker]="pickerCompletedAt">
      <input matStartDate placeholder="Inicio" [(ngModel)]="additionalFilters.start_completed_at" [ngModelOptions]="{standalone: true}" ngDefaultControl>
      <input matEndDate placeholder="Fin" [(ngModel)]="additionalFilters.end_completed_at" [ngModelOptions]="{standalone: true}" ngDefaultControl>
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="pickerCompletedAt"></mat-datepicker-toggle>
    <mat-date-range-picker #pickerCompletedAt></mat-date-range-picker>
  </mat-form-field>

  <mat-checkbox [(ngModel)]="additionalFilters.include_completed" [ngModelOptions]="{standalone: true}">
    Incluir trabajos completados
  </mat-checkbox>
</div>


<div mat-dialog-actions class="footer">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button cdkFocusInitial (click)="export()">Exportar</button>
</div>